/** A missing auth/IPC reply must settle the picker instead of leaving it busy forever. */
export const withStudioOperationDeadline = async <T>(
  operation: () => Promise<T>,
  stage: string,
  timeoutMs = 30_000
): Promise<T> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    // Bound each prerequisite, not the whole workflow: after a timeout the
    // caller stops before the next cloud mutation, even if IPC replies late.
    // Per ai-code-requires-tests and think-in-systems (ai.knowledge/global).
    return await Promise.race([
      operation(),
      new Promise<never>((_resolve, reject) => {
        timer = setTimeout(() => {
          reject(new Error(`Studio operation timed out during ${stage}. Please try again.`));
        }, timeoutMs);
      })
    ]);
  } finally {
    clearTimeout(timer);
  }
};
